import React from 'react';
function Paragraph({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 4v16M9 4h3M12 4c2.667 0 6 .625 6 5s-4 5-6 5M9 14h3"
      />
    </svg>
  );
}

export default Paragraph;
